// admin/src/Component/OutOfHomeCampaign/List.js
import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    BooleanField,
    Filter,
    TextInput,
    BooleanInput,
    usePermissions,
    Pagination,
    NumberField,
    ReferenceField
} from 'react-admin';

import UploadSpreadsheets from './UploadSpreadsheets';
import CreateDashboard from "./CreateDashboard";
import authProvider from "../../authProvider";
import DashboardLinkField from "./DashboardLinkField";

const ConsentFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search name" source="name" alwaysOn options={{
            autoComplete: 'off',
            inputProps: { 'data-lpignore': 'true' },
        }} />
        <BooleanInput source="location_list_only" label="Dashboards only" />
    </Filter>
);

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 500]} {...props} />;

const campaignRowStyle = (record, index) => {

    if (record && record.location_list_only === true) {
        return {
            backgroundColor: '#ffebee',
        };
    }

    if(record) {

        if (record.location_list_only === true) {
            return {
                backgroundColor: '#ffebee'
            }
        } else if (record.ready === true && record.added_to_dashboard === false) {
            return {
                backgroundColor: '#ffd78c'
            }
        }
    }


    return null;
};


export const OutOfHomeCampaignList = (props) => {

    const {permissions} = usePermissions();

    return (
    <List filters={<ConsentFilter />} {...props} title="Out of home Abri" pagination={<PostPagination/>}  perPage={100} sort={{ field: 'updateDate' , order: 'DESC' }}>
        <Datagrid rowStyle={campaignRowStyle}>

            <BooleanField source="ready" label="Ready" />
            <BooleanField source="added_to_dashboard" label="Dashboard" />

            <DashboardLinkField source="name" label="Name" />
            <NumberField source="week_number" label="Weeknumber" />
            <DateField source="start_date" locales="nl-NL"  />
            <DateField source="end_date" locales="nl-NL"  />
            <TextField source="created_by" />

            <ReferenceField label="Type" source="campaign_type" reference="out-of-home-campaign-types">
                <TextField source="type"/>
            </ReferenceField>

            <DateField source="update_date" sortBy="updateDate" showTime locales="nl-NL"  />
            <EditButton />

            <UploadSpreadsheets />

            {authProvider.isAuthorised(permissions, ['ROLE_ADMIN']) && <CreateDashboard />}

        </Datagrid>
    </List>);
};